export default __webpack_public_path__ + "src/images/packages/zannier-hotels-omaanda/c13f4d4345dc2056620f053ba04934c7-2.jpg";